module.exports = __webpack_public_path__ + "media/images/filter-close@3x-2d8156792fab949d5f88af803805c585.png";